import React from 'react';
import { Link } from 'react-router-dom';

const OneTapPrivacyPolicy: React.FC = () => {
  return (
    <section className="section">
      <div className="container">
        <div style={{ marginBottom: '2rem' }}>
          <Link 
            to="/" 
            style={{ 
              color: 'var(--accent-color)', 
              textDecoration: 'none',
              fontSize: '1rem',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            ← Back to Home
          </Link>
        </div>
        
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 style={{ 
            fontSize: '2.5rem', 
            fontWeight: '700',
            marginBottom: '1rem',
            background: 'linear-gradient(135deg, #ea580c 0%, #f59e0b 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>
            OneTap Privacy Policy
          </h1>
          <div className="section-divider"></div>
        </div>

        <div style={{ 
          maxWidth: '800px', 
          margin: '0 auto',
          lineHeight: '1.6',
          fontSize: '1rem'
        }}>
          <p style={{ marginBottom: '2rem', fontSize: '1rem' }}>
            <strong>Last Updated:</strong> September 11, 2026<br/>
            <strong>App:</strong> OneTap — Update All My Apps in One Tap<br/>
            <strong>Publisher:</strong> RapidNova<br/>
            <strong>Contact:</strong> rapidnova2025@gmail.com
          </p>

          <p style={{ marginBottom: '2rem' }}>
            OneTap ("we," "us," or "our") is an iOS app that helps you update apps and view basic device information on your iPhone. This Privacy Policy explains what information the app uses and how it is handled.
          </p>
          <p style={{ marginBottom: '2rem' }}>
            If you do not agree with this policy, please do not use the app.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>1. Information We Collect</h2>
          <p style={{ marginBottom: '1rem' }}>
            OneTap does <strong>not</strong> create an account and does <strong>not</strong> collect or store personal information such as your name, email address, Apple ID, or location.
          </p>
          <p style={{ marginBottom: '1rem' }}>
            Device details shown in the app (for example storage, battery level, and network type) are read on your device and displayed only to you. They are <strong>not</strong> sent to our servers.
          </p>
          <p style={{ marginBottom: '2rem' }}>
            We may store a small preference on your device (such as appearance mode) using on-device storage. That preference stays on your iPhone.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>2. Internet Use</h2>
          <p style={{ marginBottom: '2rem' }}>
            The app may check publicly available iOS version information to tell you whether a system update might be available. That request uses your device model identifier (for example, a hardware model string). It does <strong>not</strong> include your name, email, Apple ID, or other personal identifiers.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>3. App Store and Settings</h2>
          <p style={{ marginBottom: '2rem' }}>
            When you use actions like opening App Store updates or Privacy settings, iOS opens Apple's apps. Those apps are controlled by Apple and are subject to{' '}
            <a href="https://www.apple.com/legal/privacy/" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent-color)' }}>
              Apple's Privacy Policy
            </a>.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>4. Third-Party Services</h2>
          <p style={{ marginBottom: '2rem' }}>
            Aside from the public iOS firmware check described above and Apple's own apps you choose to open, OneTap does <strong>not</strong> use advertising trackers, analytics SDKs, or social login.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>5. Children's Privacy</h2>
          <p style={{ marginBottom: '2rem' }}>
            OneTap is not directed at children under 13, and we do not knowingly collect personal information from children. If you believe a child has provided us information, contact us and we will take appropriate steps.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>6. Changes to This Policy</h2>
          <p style={{ marginBottom: '2rem' }}>
            We may update this Privacy Policy from time to time. The "Last updated" date at the top will change when we do. Continued use of the app after an update means you accept the revised policy.
          </p>

          <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: 'inherit' }}>7. Contact</h2>
          <p style={{ marginBottom: '1rem' }}>
            Questions about this Privacy Policy:
          </p>
          <p style={{ marginBottom: '0.5rem' }}><strong>Email:</strong> rapidnova2025@gmail.com</p>
          <p style={{ marginBottom: '2rem' }}>
            <strong>RapidNova</strong><br/>
            60 Paya Lebar Road, #07-54<br/>
            Paya Lebar Square<br/>
            Singapore 409051
          </p>

          <hr style={{ margin: '3rem 0', border: 'none', borderTop: '1px solid #eee' }} />
          <p style={{ marginBottom: '0', fontSize: '0.9rem', color: '#666', fontStyle: 'italic' }}>
            This document is the privacy policy for the OneTap iOS application.
          </p>
        </div>
      </div>
    </section>
  );
};

export default OneTapPrivacyPolicy;
